var installedModules = {};
var moduleToHandlerMapping = {
	3528: {
		getter: () => (__webpack_require__.e(216).then(() => (() => (__webpack_require__(4194))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^18.0.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react",
	},
	2285: {
		getter: () => (Promise.all([__webpack_require__.e(216), __webpack_require__.e(528)]).then(() => (() => (__webpack_require__(6321))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^18.0.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-dom",
	}
};
// no consumes in initial chunks
var chunkMapping = {
	"285": [
		2285
	],
	"528": [
		3528
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping: moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}